import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
import { withCancelToken } from '@wix/form-http-essentials';
import { FIELD_TYPES } from '../../constants';
import { WIX_SERVICES_APP_ID } from '../../fields/service-dropdown/service-dropdown-settings/service-settings/constants';
const serviceSorter = (a, b)=>{
    return (a.category?.sortOrder ?? 0) - (b.category?.sortOrder ?? 0) || (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
};
const getQueryRequest = (serviceIds)=>{
    return {
        filter: {
            ...serviceIds ? {
                id: {
                    $in: serviceIds
                }
            } : {},
            appId: {
                $eq: WIX_SERVICES_APP_ID
            }
        }
    };
};
export const fetchServices = ({ httpClient: _httpClient, errorHandler })=>{
    return async ({ serviceIds })=>{
        try {
            const response = await errorHandler.withErrorHandler(()=>_httpClient.request(queryServices({
                    query: getQueryRequest(serviceIds)
                })), {
                errorCodesMap: {}
            });
            return response.data.services?.sort(serviceSorter);
        } catch (e) {
            const resolvedError = errorHandler.getResolvedError(e);
            console.error(resolvedError);
            return undefined;
        }
    };
};
export const loadInitialServicesDropdownData = async (httpClient, errorHandler, _wixCodeApi, _formId, form, environment, biLogger, signal)=>{
    if (environment.isEditor) {
        return {
            services: []
        };
    }
    const serviceIds = form.fields?.filter((field)=>field.view?.fieldType === FIELD_TYPES.SERVICES_DROPDOWN || field.view?.fieldType === FIELD_TYPES.SERVICES_MULTI_CHOICE).map((field)=>field.view?.options?.map((option)=>option.id)).flat();
    try {
        const services = await errorHandler.withErrorHandler(()=>httpClient.request(withCancelToken(queryServices({
                query: getQueryRequest(serviceIds)
            }), signal, httpClient)), {
            errorCodesMap: {}
        });
        const activeServiceIds = services?.data?.services?.map((service)=>service.id);
        if (activeServiceIds?.length) {
            biLogger?.report(uoUWidgetLoadOnLiveSiteSrc187Evid8({
                widgetName: 'service-dropdown',
                servicesIds: activeServiceIds.join(','),
                environment: JSON.stringify(environment)
            }));
        }
        return {
            services: services.data.services?.sort(serviceSorter)
        };
    } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        console.error(resolvedError);
        throw resolvedError;
    }
};

//# sourceMappingURL=fetch-services.js.map